import { REPORTS_STOCK_REQUEST } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";

export const columnDefs = [
  {
    headerName: "Stock Request Id",
    field: "stockRequestId",
    locked: true,
    hide: false,
    cellClass: "custom-ag-cell-link",
    width: 150,
    suppressMovable: true,
  },
  {
    headerName: "From Branch Id",
    field: "fromBranchId",
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "To Branch Id",
    field: "toBranchId", 
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "Request Created Time",
    field: "createdTime", 
    locked: true,
    hide: false,
    width: 200,
  },
  {
    headerName: "Request Updated Time",
    field: "updatedTime",
    locked: true,
    hide: false,
    width: 200,
  },
  {
    headerName: "Request Status",
    field: "status", 
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "Reason",
    field: "reason",
    locked: false,
    hide: false,
    width: 200,
    resizable: true,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    locked: false,
    hide: false,
    width: 200,
    resizable: true,
  },
  {
    headerName: "Company",
    field: "company",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    locked: false,
    hide: true,
    width: 150,
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    locked: false,
    hide: true,
    width: 150,
  },
  {
    headerName: "Group",
    field: "grp",
    locked: false,
    hide: true,
    width: 120,
  },
  {
    headerName: "Parent Id",
    field: "parentId",
    locked: false,
    hide: true,
    width: 120,
  },
  {
    headerName: "Source",
    field: "src",
    locked: false,
    hide: true,
    width: 120,
  },
  {
    headerName: "Deleted",
    field: "deleted",
    locked: false,
    hide: true,
    width: 100,
    cellClass: "custom-ag-cell-numeric",
  },
  {
    headerName: "Version",
    field: "__v", 
    hide: true,
    width: 80,
  },
];
export const columnDefsFunctions = {
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  status: {
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === "ACCEPTED" && { color: 'green' }),
        ...(params.value === "REJECTED" && { color: 'red' }),
        ...(params.value !== "ACCEPTED" && params.value !== "REJECTED" && { color: 'black' }),
      };
    },
  },
};

export const initial_state_stock_request_report = {
  type: REPORTS_STOCK_REQUEST,
  label: "Stock Request Report",
  allowMultipleTabs: false,
};
